import baysportLogo from "../assets/logo.png";
import L from "../constants/baysportLabels";
import {
  applyPortalBrandingToRoot,
  applyPortalThemeMode,
  buildClientHeroTheme,
  clearPortalThemeMode,
  clubBrandingSource,
  mediaUrl,
  resolvePortalThemeMode,
} from "./clientHeroTheme";

/** Тариф с брендингом (Расширенный+): логотип клуба, без «Бай.Спорт», цвета клуба. */
export function clinicHasAuthBranding(clinic) {
  const f = clinic?.features || {};
  return Boolean(
    f.branding || f.branding_lite || f.splash_branding || f.white_label,
  );
}

/**
 * Бренд для страниц входа / сброса пароля / регистрации по ссылке.
 */
export function resolveAuthPageBranding(clinic) {
  const clubName = String(clinic?.name || "").trim();
  const personalized = clinicHasAuthBranding(clinic);
  const logoSrc = mediaUrl(clinic?.logo_url) || null;
  const themeMode =
    personalized && resolvePortalThemeMode(clinic) === "dark" ? "dark" : "light";

  if (!personalized) {
    return {
      personalized: false,
      logoSrc: baysportLogo,
      brandTitle: L.productName,
      showProductName: true,
      applyColors: false,
      themeMode: "light",
      clubTag: clubName || null,
    };
  }

  return {
    personalized: true,
    logoSrc: logoSrc || null,
    brandTitle: clubName || null,
    showProductName: false,
    applyColors: true,
    themeMode,
    clubTag: null,
  };
}

/** Применить цвета и светлую/тёмную тему клуба на documentElement. */
export function applyAuthPageTheme(clinic) {
  const brand = resolveAuthPageBranding(clinic);

  if (!brand.applyColors) {
    clearPortalThemeMode();
    return brand;
  }

  const source = clubBrandingSource(clinic);
  const dark = brand.themeMode === "dark";
  applyPortalThemeMode(dark ? "dark" : "light");
  const theme = buildClientHeroTheme(source);
  if (theme) applyPortalBrandingToRoot(theme, { dark });
  return brand;
}
